import apiFactory from '../utils/api-factory'
import logUtil from '../utils/log-util'

const logger = logUtil

export async function loadUserPreferences() {
  try {
    logger.log('Getting user preferences')
    const response = await apiFactory.getUserPreferences()
    logger.log('Getting user preferences completed')

    return response
  } catch (error) {
    throw error
  }
}
